import { SidePanel } from '@issuemanager/apps/client/components';
import { ButtonProps, Stack, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { Footer } from './footer';

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  onSend: () => void;
  onCancel: () => void;
  title: string;
  description: ReactNode;
  actionButton: ButtonProps & { 'data-testid'?: string };
  cancelButton?: ButtonProps;
  actionButtonText: string;
  content: React.JSX.Element;
};

export function LayoutPanel(props: Props) {
  const {
    title,
    description,
    isOpen,
    content,
    onCancel,
    cancelButton,
    ...rest
  } = props;

  return (
    <SidePanel
      open={isOpen}
      onClose={onCancel}
      title={title}
      footer={
        <Footer {...rest} onCancel={onCancel} cancelButton={cancelButton} />
      }
    >
      <Typography component='div' mb={3}>
        {description}
      </Typography>
      <Stack>{content}</Stack>
    </SidePanel>
  );
}
